import PropTypes from 'prop-types';

export default PropTypes.arrayOf(PropTypes.shape({
  ENTRY_DATE: PropTypes.string,
  TAX_YEAR: PropTypes.string,
  COMPANY_CODE: PropTypes.string,
  TRADING_PARTNER: PropTypes.string,
  COUNTRY_TAX_TYPE: PropTypes.string,
  SL_ACCOUNT: PropTypes.string,
  BOOK_TYPE: PropTypes.string,
  DESCRIPTION: PropTypes.string,
  CURRENCY_CODE: PropTypes.string,
  DEBIT: PropTypes.number,
  CREDIT: PropTypes.number,
})).isRequired;
